import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiEndpoints {
  readonly baseUrl = environment.baseUrl;
  readonly baseUrlV2 = environment.baseUrlV2;
  readonly auth = '/auth';
  readonly deliveryOptions = '/delivery/options';
  readonly accessRequest = '/access/booking';
  readonly accessRequestKinesis = '/kinesis/access/booking';
  readonly accessId = '/accessid';
  readonly accessKey = '/access/key';
  readonly accessEvent = '/access/event';
  readonly accessDeviation = '/access/deviation';
  readonly open = '/open';
  readonly lock = '/lock';
  readonly ping = '/position/byhonkblink';
  readonly position = '/position/bycoordinates';
  readonly revoke = '/revoke';
  readonly capacity = '/capacity';
  readonly changeCompartment = '/change/compartment';
  readonly openAllCompartments = '/access/keys/all';
  readonly hardwareIds = '/hardwareids';
  readonly inspectEvent = '/inspect/event';
  readonly incidentReport = '/incident/report';

  url(path: string): string {
    return `${this.baseUrl}${path}`;
  }
}